// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"268":"events","472":"settings","671":"services","861":"myvb","887":"apps","946":"news"}[chunkId] + "." + {"268":"a3ee0e2a","472":"5dddea35","671":"edf2cec9","861":"f24e32ff","887":"62718bf1","946":"7cee37ca"}[chunkId] + ".css";
};